import React from 'react';

const DashboardCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_95_21841)">
      <path
        d="M11.3335 4.16666H18.0002"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3335 7.5H15.5002"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3335 12.5H18.0002"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3335 15.8333H15.5002"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.16667C3 3.94566 3.0878 3.73369 3.24408 3.57741C3.40036 3.42113 3.61232 3.33334 3.83333 3.33334H7.16667C7.38768 3.33334 7.59964 3.42113 7.75592 3.57741C7.9122 3.73369 8 3.94566 8 4.16667V7.5C8 7.72102 7.9122 7.93298 7.75592 8.08926C7.59964 8.24554 7.38768 8.33334 7.16667 8.33334H3.83333C3.61232 8.33334 3.40036 8.24554 3.24408 8.08926C3.0878 7.93298 3 7.72102 3 7.5V4.16667Z"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.5C3 12.279 3.0878 12.067 3.24408 11.9107C3.40036 11.7545 3.61232 11.6667 3.83333 11.6667H7.16667C7.38768 11.6667 7.59964 11.7545 7.75592 11.9107C7.9122 12.067 8 12.279 8 12.5V15.8333C8 16.0543 7.9122 16.2663 7.75592 16.4226C7.59964 16.5789 7.38768 16.6667 7.16667 16.6667H3.83333C3.61232 16.6667 3.40036 16.5789 3.24408 16.4226C3.0878 16.2663 3 16.0543 3 15.8333V12.5Z"
        stroke="#898989"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_95_21841">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default DashboardCardIcon; 